import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Alert from "@material-ui/lab/Alert";
var useStyles = makeStyles(function (theme) {
  return createStyles({
    root: {
      display: "flex",
      alignItems: "flex-start",
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: "#FDF7EC",
      color: "#1F1F1F"
    },
    iconWrapper: {
      width: 28,
      height: 28,
      borderRadius: "50%",
      backgroundColor: theme.palette.common.white,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: theme.spacing(1.5),
      flexShrink: 0
    },
    warningIcon: {
      color: "#D69B3B",
      fontSize: 18,
      position: "relative",
      top: "-30px"
    },
    content: {
      flex: 1
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: theme.spacing(0.5)
    },
    title: {
      fontWeight: 600
    },
    description: {
      fontSize: 14,
      lineHeight: 1.4
    },
    closeButton: {
      padding: theme.spacing(0.5)
    }
  });
});
var DuplicateOrderAlert = function DuplicateOrderAlert(_ref) {
  var duplicateOrderDate = _ref.duplicateOrderDate,
    setIsDuplicateOrder = _ref.setIsDuplicateOrder;
  var classes = useStyles();
  var d = new Date(duplicateOrderDate);
  var formattedDate = "".concat((d.getMonth() + 1).toString().padStart(2, "0"), "/").concat(d.getDate().toString().padStart(2, "0"), "/").concat(d.getFullYear());
  return React.createElement(Alert, {
    severity: "warning",
    style: {
      margin: "5px 0"
    },
    action: React.createElement(IconButton, {
      className: classes.warningIcon,
      "aria-label": "close",
      color: "inherit",
      size: "small",
      onClick: function onClick() {
        setIsDuplicateOrder(false);
      }
    }, React.createElement(CloseIcon, {
      fontSize: "inherit"
    }))
  }, React.createElement("div", {
    className: classes.content
  }, React.createElement("div", {
    className: classes.header
  }, React.createElement(Typography, {
    variant: "subtitle1",
    className: classes.title
  }, "Duplicate order")), React.createElement(Typography, {
    className: classes.description
  }, "This appears to be a duplicate of an order for the same patient and test from ", formattedDate, ". If this is intentional, you can continue. Otherwise, review the existing order to avoid duplicate processing.")));
};
export default DuplicateOrderAlert;